import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "recompact"
import isEmpty from "lodash/isEmpty"
import filter from "lodash/filter"
import sortBy from "lodash/sortBy"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import Select from "@infotech/uikit-select"
import { updateList } from "src/engine/modules/lists/actions/creators/update"
import { refreshToken } from "src/engine/modules/session/actions/creators"
import { selectToken } from "src/engine/modules/session/selectors"
import { LIST_NAME, getBasicUrl } from "./helper/constants"
import getTemplatesList from "./helper/templatesApi"
import List from "./Lists"
import ReadOnlyList from "./Lists/readOnlyList"
import styles from "./styles.css"

const createFirstText = `Чтобы добавить шаблоны отчетов, создайте план.`

const TemplatesPart = ({
  plan: { isVirtual, id },
  planTypes,
  updateList,
  currentToken,
  planTypeId,
  isDisabled,
}) => {
  const [templatesList, getList] = useState([])
  useEffect(() => {
    if (
      currentToken &&
      templatesList &&
      (isEmpty(templatesList.data) || templatesList.status === `fail`)
    ) {
      getTemplatesList(currentToken, getList)
    }
  }, [id, currentToken])
  /*
  Получив список шаблонов, мы должны убрать те элементы у которых поле code не представляет из себя uuid
  и отсортировать по названию.
  * */
  const templatesOptions =
    (templatesList &&
      templatesList.status === `completed` &&
      templatesList.data &&
      !isEmpty(templatesList.data) &&
      sortBy(
        filter(
          templatesList.data.map(item => ({
            value: item.code,
            label: item.name,
            data: item,
          })),
          option => Boolean(option),
        ),
        item => item.label,
      )) ||
    []
  const loadingTemplates = !isVirtual && isEmpty(templatesOptions)
  return (
    <Box loose>
      <Box loose pl="2md" pr="2md" pt="2md">
        <FieldSet caption="Шаблоны отчетов">
          <div data-testid="plans-report-templates-select">
            <Select
              placeholder="Выберите шаблоны отчетов"
              isDisabled={isVirtual || isEmpty(templatesOptions) || isDisabled}
              isLoading={!isVirtual && !(templatesList && templatesList.status)}
              options={templatesOptions}
              autoFocus={false}
              onFocus={null}
              onChange={({ target: { value: option } }) =>
                updateList({
                  basicUrl: getBasicUrl(id),
                  name: LIST_NAME,
                  id: option.value,
                })
              }
              value={null}
            />
          </div>
        </FieldSet>
      </Box>
      {isVirtual && (
        <Box pl="2md" loose className={styles.FirstCreateLabel}>
          {createFirstText}
        </Box>
      )}
      <Box>
        {!isVirtual && !isEmpty(templatesOptions) && (
          <List
            planId={id}
            isVirtual={isVirtual}
            templates={templatesList}
            isLoading={loadingTemplates}
            isDisabled={isDisabled}
          />
        )}
        {isVirtual && planTypes.data && planTypeId && (
          <ReadOnlyList
            planTypeId={planTypeId}
            planTypes={planTypes}
            currentToken={currentToken}
          />
        )}
      </Box>
    </Box>
  )
}

TemplatesPart.propTypes = {
  id: PropTypes.oneOf([`string`, `number`]),
  isVirtual: PropTypes.bool,
  currentToken: PropTypes.string.isRequired,
  updateList: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

TemplatesPart.defaultProps = {
  isVirtual: false,
  id: null,
}

export default compose(
  connect(
    state => ({
      currentToken: selectToken(state),
    }),
    {
      updateList,
      refreshToken,
    },
  ),
)(TemplatesPart)
